import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import * as fromStore from '../../_store';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { take } from 'rxjs/operators';
import { ScreenService } from '@ibe/services/ui';
import { PAX_TYPE_INFANT_CODE, PAX_TYPE_CHILD_CODE, PAX_TYPE_YOUNG_ADULT_CODE } from '@ibe.config';
var INDRAPassengerDetailMainInfoComponent = /** @class */ (function () {
    function INDRAPassengerDetailMainInfoComponent(fb, store, globalStore, screen) {
        var _this = this;
        this.fb = fb;
        this.store = store;
        this.globalStore = globalStore;
        this.screen = screen;
        this.displayValidationMessages = false;
        this.showAdditionalFields = false;
        this.departureDate = "";
        this.form = this.fb.group({
            title: [null],
            name: [null, [Validators.required, Validators.pattern('[a-zA-Z ]+')]],
            surname: [null, [Validators.required, Validators.pattern('[a-zA-Z ]+'), this.INDRA_checkMinLengthWithTrim(2)]],
            gender: [null],
            birthDate: [null],
            isNew: [true]
        }, {
            validator: this.INDRA_checkNameLength('name', 'surname')
        });
        this.titleOptions = [
            { text: 'bookingDetails.label.mr', value: 'Mr' },
            { text: 'bookingDetails.label.mrs', value: 'Mrs' },
        ];
        this.genderCodes = [
            { text: 'bookingDetails.label.male', value: 'Male' },
            { text: 'bookingDetails.label.female', value: 'Female' }
        ];
        this.isMobile = false;
        this.sub$ = new Subscription();
        this._hasChanges = new BehaviorSubject(false);
        this.screen.isMobile().subscribe(function (value) {
            _this.isMobile = value;
        });
    }
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "passengerInfo", {
        get: function () {
            return this._passengerInfo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "hasChanges", {
        get: function () {
            return this._hasChanges.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "hasErrorClassTitle", {
        get: function () {
            return this.form.get('title').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "hasErrorClassFirstName", {
        get: function () {
            return this.form.get('name').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "hasErrorClassLastName", {
        get: function () {
            return this.form.get('surname').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "hasErrorClassGender", {
        get: function () {
            return this.form.get('gender').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "hasData", {
        get: function () {
            return !_.isEmpty(this.form.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "hasErrors", {
        get: function () {
            return !_.isEmpty(this.form.errors);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "isInfant", {
        get: function () {
            return Object.is(PAX_TYPE_INFANT_CODE, this.passengerInfo.typePax);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "isChild", {
        get: function () {
            return Object.is(PAX_TYPE_CHILD_CODE, this.passengerInfo.typePax);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailMainInfoComponent.prototype, "isYoungAdult", {
        get: function () {
            return Object.is(PAX_TYPE_YOUNG_ADULT_CODE, this.passengerInfo.typePax);
        },
        enumerable: true,
        configurable: true
    });
    INDRAPassengerDetailMainInfoComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub$.add(this.store.select(fromStore.getSelectedPassengersAtIndex)
            .subscribe(function (passenger) {
            if (passenger) {
                _this._passengerInfo = passenger;
                _this.mapPassengerToForm(passenger);
                _this.updateFormValidation();
                // this.verifyFormValidations();
            }
        }));
        this.sub$.add(this.form.valueChanges.subscribe(function () { return _this._hasChanges.next(true); }));
        this.formValueChangesUpdateMainInfo();
    };
    INDRAPassengerDetailMainInfoComponent.prototype.updateFormValidation = function () {
        if (this.isInfant || this.isChild || this.isYoungAdult || this.showAdditionalFields) {
            this.form.get('gender').setValidators([Validators.required]);
            this.form.get('birthDate').setValidators([Validators.required]);
        }
        if (!this.isInfant && !this.isChild) {
            this.form.get('title').setValidators([Validators.required]);
        }
    };
    INDRAPassengerDetailMainInfoComponent.prototype.formValueChangesUpdateMainInfo = function () {
        var _this = this;
        this.sub$.add(this.form.get('title').valueChanges.subscribe(function () { return _this.dispatchUpdateMainInfo(); }));
        this.sub$.add(this.form.get('name').valueChanges.subscribe(function (data) {
            var regex = /^[a-zA-Z0-9_ ]+$/;
            var isValid = regex.test(data);
            if (isValid) {
                _this.dispatchUpdateMainInfo();
                return;
            }
            else {
                if (data && data !== _this.INDRA_removeSpecialCharacters(data)) {
                    _this.form.controls['name'].patchValue(_this.INDRA_removeSpecialCharacters(data));
                    _this.dispatchUpdateMainInfo();
                }
                return;
            }
        }));
        this.sub$.add(this.form.get('surname').valueChanges.subscribe(function (data) {
            var regex = /^[a-zA-Z0-9_ ]+$/;
            var isValid = regex.test(data);
            if (isValid) {
                _this.dispatchUpdateMainInfo();
                return;
            }
            else {
                if (data && data !== _this.INDRA_removeSpecialCharacters(data)) {
                    _this.form.controls['surname'].patchValue(_this.INDRA_removeSpecialCharacters(data));
                    _this.dispatchUpdateMainInfo();
                }
                return;
            }
        }));
        // added since this passenger main info is required
        this.dispatchUpdateMainInfo();
        if (this.isInfant || this.isChild || this.isYoungAdult || this.showAdditionalFields) {
            this.sub$.add(this.form.get('birthDate').valueChanges.subscribe(function () { return _this.dispatchUpdateDocument(); }));
            this.sub$.add(this.form.get('gender').valueChanges.subscribe(function () { return _this.dispatchUpdateDocument(); }));
            // added since this passenger document section (birthDate and gender field) is required for children and infant
            this.dispatchUpdateDocument();
        }
    };
    INDRAPassengerDetailMainInfoComponent.prototype.dispatchUpdateMainInfo = function () {
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateMainInfo': true }));
    };
    INDRAPassengerDetailMainInfoComponent.prototype.dispatchUpdateDocument = function () {
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateDocument': true }));
    };
    INDRAPassengerDetailMainInfoComponent.prototype.mapPassengerToForm = function (data) {
        // note: a surname with number indicates the initial pax coming from a dummy PNR (pre-pax creation)
        this.form.patchValue({
            title: data.title,
            name: (data.surname && isNaN(data.surname)) ? data.name : '',
            surname: (data.surname && isNaN(data.surname)) ? data.surname : '',
            gender: (data.listTravelDoc && data.listTravelDoc[0]) ? data.listTravelDoc[0].gender : null,
            birthDate: (data.listTravelDoc && data.listTravelDoc[0]) ? data.listTravelDoc[0].birthDate : null,
            isNew: data.isNew
        }, { emitEvent: false });
    };
    INDRAPassengerDetailMainInfoComponent.prototype.ngOnDestroy = function () {
        this.sub$.unsubscribe();
    };
    INDRAPassengerDetailMainInfoComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    INDRAPassengerDetailMainInfoComponent.prototype.formMainInfoErrors = function (control) {
        var errors = [];
        if (Object.is('title', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.titleRequired');
            }
        }
        if (Object.is('name', control)) {
            if (this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.firstNameInvalid');
            }
            else if (this.form.controls['surname'].hasError('pattern') && this.isMobile) {
                errors.push('bookingDetails.error.lastNameInvalid');
            }
            else if ((this.form.controls[control].hasError('required') || this.form.controls['surname'].hasError('required')) && this.isMobile) {
                errors.push('bookingDetails.error.firstNameLastNameRequired');
            }
            else if (this.form.controls[control].hasError('required') && !this.isMobile) {
                errors.push('bookingDetails.error.firstNameRequired');
            }
        }
        if (Object.is('surname', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.lastNameRequired');
            }
            if (this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.lastNameInvalid');
            }
            if (this.form.controls[control].hasError('minlength')) {
                errors.push('bookingDetails.error.lastNameMoreThanChar');
            }
        }
        if (Object.is('gender', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocGenderRequired');
            }
        }
        if (Object.is('birthDate', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocFullBirthDateRequired');
            }
            if (this.form.controls[control].hasError('invalidDate')) {
                errors.push('bookingDetails.error.personalDocFullBirthDateRequired');
            }
        }
        if (Object.is('maxNameCharReached', control)) {
            if (this.form.hasError(control)) {
                errors.push('bookingDetails.error.maxNameCharExceeded');
            }
        }
        return errors.join('; ');
    };
    INDRAPassengerDetailMainInfoComponent.prototype.clearForm = function () {
        this.form.reset({ emitEvent: false });
    };
    INDRAPassengerDetailMainInfoComponent.prototype.cancelEdit = function () {
        var _this = this;
        this.store.select(fromStore.getSelectedPassengersAtIndex)
            .pipe(take(1)).subscribe(function (data) {
            _this.form.reset({
                title: data.title,
                name: data.name,
                surname: data.surname
            }, { emitEvent: false });
            _this._hasChanges.next(false);
        });
        this.store.dispatch(new fromStore.UpdateFormChangedAction({
            'updateMainInfo': false,
        }));
    };
    INDRAPassengerDetailMainInfoComponent.prototype.INDRA_removeSpecialCharacters = function (value) {
        return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };
    INDRAPassengerDetailMainInfoComponent.prototype.INDRA_checkNameLength = function (firstNameControl, secondNameControl) {
        return function (control) {
            if (control.get(firstNameControl).value && control.get(secondNameControl).value) {
                var firstname = control.get(firstNameControl).value.length;
                var lastname = control.get(secondNameControl).value.length;
                // max characters for combined first and last name should not exceed 31 characters
                if (firstname + lastname > 31) {
                    return { 'maxNameCharReached': true };
                }
                else {
                    return null;
                }
            }
        };
    };
    INDRAPassengerDetailMainInfoComponent.prototype.INDRA_checkMinLengthWithTrim = function (minimumLength) {
        return function (control) {
            if (control.value && control.value.trim().length < minimumLength) {
                return { 'minlength': true };
            }
            return null;
        };
    };
    return INDRAPassengerDetailMainInfoComponent;
}());
export { INDRAPassengerDetailMainInfoComponent };
